/**
 * Generate icon component
 * @param {Component} Component component which renders an svg
 * @return {Componet} Component rendering svg wrapped in .icon span
 */
export const asIcon = (Component) => {
    function Icon(props) {
        return (
            <span className="icon" data-testid="as-icon">
                <Component {...props} />
            </span>
        );
    }

    return Icon;
};
